export default __webpack_public_path__ + "static/media/back-link-icon.e3c78c37.svg";